import { Routes, Route, Outlet } from "react-router-dom";
import Error404 from "./pages/Error404";
import EntryCbb from "./pages/EntryCbb";
import EntryOmni from "./pages/EntryOmni";
import MultiChat from "./pages/MultiChat";
import Environment from "./services/environment";
import "./style/main.css";
import "./style/entry.css";
import { useEffect } from "react";
import consoleController from "./utils/console.controller";

const envData = Environment();

function App() {
  useEffect(() => {
    consoleController.checkAndToggle();
  }, []);

  return (
    <Routes>
      <Route
        element={
          <div className="livebot_root">
            <Outlet />
          </div>
        }
      >
        <Route path="/" element={<Error404 />} />
        <Route
          path="/:url"
          element={envData.isAI ? <EntryCbb /> : <EntryOmni />}
        />
        <Route
          path="/preview/:url"
          element={envData.isAI ? <EntryCbb /> : <EntryOmni />}
        />
        // for outgrow
        <Route path="/agent/:url" element={<EntryCbb outgrow={true} />} />
        <Route
          path="/agent/preview/:url"
          element={<EntryCbb outgrow={true} />}
        />
        {/* <Route path="/multichat/:url" element={<MultiChat />} /> */}
        <Route path="/error" element={<Error404 />} />
      </Route>
    </Routes>
  );
}

export default App;
